/**
 * Picks v2 or v1 of the Audiobooks page based on the redesign flag.
 * Same pattern as QuickTapsPageSwitch / CategoriesPageSwitch / etc.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import AudioBookPage   from './AudioBookPage';
import AudioBookPageV2 from './AudioBookPageV2';

export default function AudioBookPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AudioBookPageV2 : AudioBookPage;
  return <Component {...props} />;
}
